import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47f1d2c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "experience-card__sale-ended"
}
const _hoisted_2 = {
  key: 2,
  class: "experience-card__fetching"
}
const _hoisted_3 = { key: 3 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "experience-card__divider" }, null, -1))
const _hoisted_5 = { class: "experience-card__body" }
const _hoisted_6 = { class: "experience-card__expandable-section" }
const _hoisted_7 = { class: "experience-card__expandable-header" }
const _hoisted_8 = {
  key: 0,
  class: "experience-card__additional-service-list"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "experience-card__divider--nested" }, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "experience-card__period"
}
const _hoisted_11 = { class: "experience-card__label" }
const _hoisted_12 = { class: "experience-card__label" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "experience-card__divider--nested" }, null, -1))
const _hoisted_14 = { class: "experience-card__footer" }
const _hoisted_15 = { class: "experience-card__total" }
const _hoisted_16 = {
  key: 0,
  class: "experience-card__total-price"
}
const _hoisted_17 = {
  key: 0,
  class: "experience-card__label"
}
const _hoisted_18 = { class: "experience-card__prices-wrapper" }
const _hoisted_19 = {
  key: 0,
  class: "experience-card__price experience-card__price--base experience-card__price--discounted"
}
const _hoisted_20 = { class: "experience-card__action" }

import { computed, PropType, ref, watch } from 'vue'
import { formatCurrency, formatIntlDateAndTime } from '@/utils/formatters'
import ExperienceSearch from '@/components/public/ExperienceSearch.vue'
import ExperienceSelectionOverview from '@/components/public/experience/ExperienceSelectionOverview.vue'
import { ALERT_TYPES, FORMATS, SIZES } from '@/enums/components'
import BaseButton from '../BaseButton.vue'
import {
  ExperienceInformation,
  ExperienceInformationPayload,
  ExperiencePeriodAvailabilityPayload,
} from '@/models/public/service.model'
import { getValidationErrorData } from '@/utils/errors'
import { Alert } from '@/models/shared.model'
import {
  useCreateOrderMutation,
  createOrUpdateExperienceServiceOrderItem,
} from '@/queries/cart'
import { OrderItem } from '@/models/public/order.model'
import { useOrderStore } from '@/store/order'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import { isNumeric } from '@/utils/general'
import AdditionalServiceCard, {
  AdditionalServiceInformationWithQuantity,
} from './AdditionalServiceCard.vue'
import parseISO from 'date-fns/parseISO'
import { useFetchServiceExperienceInformationMutation } from '@/queries/public/services'
import { debounce } from 'lodash'
import { serviceResultCardCommonProps } from '@/enums/public'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExperienceResultCard',
  props: {
  ...serviceResultCardCommonProps,
  selectedDate: {
    type: Date as PropType<Date | null>,
    default: null,
  },
  selectedGroupSize: {
    type: Number as PropType<number | undefined>,
    default: undefined,
  },
},
  emits: ['cartUpdated'],
  setup(__props, { emit: emits }) {

const props = __props

const orderStore = useOrderStore()
const i18n = useI18n()
const toast = useToast()



const additionalServiceQuantities = ref<Record<string, number>>({})
const selectedExperiencePayload =
  ref<ExperiencePeriodAvailabilityPayload | null>(null)

const experienceInfo = ref<ExperienceInformation | undefined>(undefined)
const isAdditionalServicesExpanded = ref<boolean>(true)
const isRequestsExpanded = ref<boolean>(false)
const isAddToCartLoading = ref<boolean>(false)
const errors = ref<Record<string, unknown> | undefined>(undefined)

const isSalesEnded = computed<boolean>(() => {
  if (!experienceInfo.value?.sale_ends_at) {
    return false
  }
  const saleEndsAt = parseISO(experienceInfo.value?.sale_ends_at)
  const currentMoment = new Date()
  return currentMoment > saleEndsAt
})

const anySelected = computed<boolean>(() => {
  return (
    selectedExperiencePayload.value.start && selectedExperiencePayload.value.end
  )
})

const payload = computed(() => {
  return {
    service: props.service.id,
    group_size: selectedExperiencePayload.value.group_size,
    requests: '',
    start: selectedExperiencePayload.value.start,
    end: selectedExperiencePayload.value.end,
    additional_services: additionalServiceQuantities.value,
    referral_type: props.referral?.referral_type,
    referral_code: props.referral?.referral_code,
    item_group: null,
  }
})

const { mutateAsync: createOrder } = useCreateOrderMutation()

const { mutateAsync: fetchExperienceInfo, isLoading: isLoadingExperienceInfo } =
  useFetchServiceExperienceInformationMutation(props.service.hash_id)

const addExperienceServiceItemToCart = async () => {
  isAddToCartLoading.value = true
  errors.value = undefined
  if (!orderStore.orderUuid) {
    try {
      const data = await createOrder()
      orderStore.updateOrder(data)
    } catch (error: unknown) {
      errors.value = getValidationErrorData(error)
      isAddToCartLoading.value = false
      return
    }
  }

  createOrUpdateExperienceServiceOrderItem(orderStore.orderUuid, payload.value)
    .then((response) => {
      orderStore.updateOrder(response.data)
      toast.success(i18n.t('addToCartSuccess'))
      emits('cartUpdated')
    })
    .catch((error) => {
      errors.value = getValidationErrorData(error)
    })
    .finally(() => {
      isAddToCartLoading.value = false
    })
}

const isDiscounted = computed<boolean>(() => {
  return (
    experienceInfo.value?.base_total !== experienceInfo.value?.discounted_total
  )
})

/**
 * Whether service pricing's minimum price logic was enforeced
 */
const isMinimumPrice = computed<boolean>(() => {
  return experienceInfo.value ? experienceInfo.value.is_minimum_price : false
})

const additionalServicesWithQuantities = computed<
  AdditionalServiceInformationWithQuantity[]
>(() => {
  const additionalServices = experienceInfo.value?.additional_services || []

  return additionalServices.map((item) => {
    return {
      ...item,
      quantity: additionalServiceQuantities.value[item.id] || 0,
    }
  })
})

const matchingItemInCart = computed<OrderItem | undefined>(() => {
  for (const item of orderStore.items) {
    // Shouldn't match against order item that is part of a group
    if (item.item_group !== null) {
      continue
    }
    if (item.service === props.service.id) {
      return item
    }
  }
  return undefined
})

const updateExperienceInfo = (payload: ExperiencePeriodAvailabilityPayload) => {
  const fetchPayload: ExperienceInformationPayload = {
    ...payload,
    additional_services: additionalServiceQuantities.value,
    group_service: props.groupService,
  }
  fetchExperienceInfo(fetchPayload)
    .then((data) => {
      experienceInfo.value = data
    })
    .catch((error) => {
      errors.value = getValidationErrorData(error)
    })
}

const debouncedUpdateExperienceInfo = debounce(updateExperienceInfo, 400)

watch(
  () => selectedExperiencePayload.value,
  () => {
    experienceInfo.value = undefined
    additionalServiceQuantities.value = {}
    if (selectedExperiencePayload.value) {
      debouncedUpdateExperienceInfo(selectedExperiencePayload.value)
    }
  },
)

const alerts = computed<Alert[]>(() => {
  const alertList: Alert[] = []
  const nonFieldErrors = (errors.value?.non_field_errors || []) as Array<string>
  for (const errorMessage of nonFieldErrors) {
    alertList.push({
      text: errorMessage,
      alertType: ALERT_TYPES.DANGER,
    })
  }

  if (isMinimumPrice.value) {
    alertList.push({
      text: i18n.t('servicePeriodPricing.isMinimumPriceWarningAlert'),
      alertType: ALERT_TYPES.WARNING,
    })
  }
  return alertList
})

const getPriceWithAdditionalServices = (
  basePrice: string | null | undefined,
) => {
  if (!basePrice || !isNumeric(basePrice)) {
    return '- €'
  }
  const totalPrice = additionalServicesWithQuantities.value.reduce(
    (acc: number, value: AdditionalServiceInformationWithQuantity) =>
      acc + value.quantity * +value.price,
    +basePrice,
  )
  return formatCurrency(totalPrice)
}



return (_ctx: any,_cache: any) => {
  const _component_AlertBanner = _resolveComponent("AlertBanner")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["experience-card", { 'result-card--grouped': !!props.groupService }])
  }, [
    (_unref(isSalesEnded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_AlertBanner, {
            text: _ctx.$t('eventService.eventSalesEnded'),
            "alert-type": _unref(ALERT_TYPES).INFO
          }, null, 8, ["text", "alert-type"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showSelectedMode)
      ? (_openBlock(), _createBlock(ExperienceSearch, {
          key: 1,
          service: _ctx.service,
          "is-disabled": _unref(isSalesEnded),
          "group-service": _ctx.groupService,
          "selected-date": __props.selectedDate,
          "selected-group-size": __props.selectedGroupSize,
          onFetchInfo: _cache[0] || (_cache[0] = (payload) => (selectedExperiencePayload.value = payload))
        }, null, 8, ["service", "is-disabled", "group-service", "selected-date", "selected-group-size"]))
      : _createCommentVNode("", true),
    (_unref(isLoadingExperienceInfo))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LoadingSpinner)
        ]))
      : _createCommentVNode("", true),
    (experienceInfo.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!_ctx.showSelectedMode)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_4,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alerts), (alert, alertIndex) => {
                  return (_openBlock(), _createBlock(_component_AlertBanner, _mergeProps({ key: alertIndex }, alert), null, 16))
                }), 128)),
                _createElementVNode("div", _hoisted_5, [
                  (_unref(additionalServicesWithQuantities).length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(BaseButton, {
                              label: _ctx.$t('additionalServices'),
                              format: _unref(FORMATS).TERTIARY,
                              size: _unref(SIZES).MEDIUM,
                              icon: 
                    isAdditionalServicesExpanded.value ? 'chevron-up' : 'chevron-down'
                  ,
                              "icon-right": true,
                              class: "experience-card__section-toggle",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
                    isAdditionalServicesExpanded.value = !isAdditionalServicesExpanded.value
                  ), ["prevent"]))
                            }, null, 8, ["label", "format", "size", "icon"])
                          ]),
                          (isAdditionalServicesExpanded.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(additionalServicesWithQuantities), (item) => {
                                  return (_openBlock(), _createBlock(AdditionalServiceCard, {
                                    key: item.id,
                                    "model-value": item,
                                    "onUpdate:modelValue": 
                    (item) =>
                      (additionalServiceQuantities.value[item.id] = item.quantity)
                  
                                  }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_9
                      ], 64))
                    : _createCommentVNode("", true),
                  (experienceInfo.value?.start && experienceInfo.value?.end)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('start')) + ": ", 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(formatIntlDateAndTime)(experienceInfo.value?.start)), 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('end')) + ": ", 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(formatIntlDateAndTime)(experienceInfo.value?.end)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_13
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (!_ctx.isPriceHidden)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (!_ctx.showSelectedMode!)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('price.priceLabel')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      (_unref(isDiscounted))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(getPriceWithAdditionalServices(experienceInfo.value?.base_total)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(["experience-card__price", [
                  _unref(isDiscounted) &&
                    !_unref(isMinimumPrice) &&
                    'experience-card__price--discounted',
                  _unref(isMinimumPrice) && 'experience-card__price--minimum-price',
                ]])
                      }, _toDisplayString(getPriceWithAdditionalServices(
                    experienceInfo.value?.discounted_total,
                  )), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showSelectedMode && selectedExperiencePayload.value)
                ? (_openBlock(), _createBlock(ExperienceSelectionOverview, {
                    key: 1,
                    start: selectedExperiencePayload.value.start,
                    end: selectedExperiencePayload.value.end,
                    "group-size": selectedExperiencePayload.value.group_size,
                    "additional-services": additionalServiceQuantities.value
                  }, null, 8, ["start", "end", "group-size", "additional-services"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _renderSlot(_ctx.$slots, "addButton", {
                payload: _unref(payload),
                contentSelected: _unref(anySelected)
              }, () => [
                _createVNode(BaseButton, {
                  format: _unref(FORMATS).PRIMARY,
                  size: _unref(SIZES).SMALL,
                  label: _unref(matchingItemInCart) ? _ctx.$t('updateInCart') : _ctx.$t('addToCart'),
                  loading: isAddToCartLoading.value,
                  class: _normalizeClass(["experience-card__action", 
                _unref(matchingItemInCart)
                  ? 'experience-card__action--update'
                  : 'experience-card__action--add'
              ]),
                  icon: "shopping-cart",
                  disabled: _ctx.isPreview || !_ctx.service.id || !_unref(anySelected),
                  "icon-right": "",
                  onClick: _withModifiers(addExperienceServiceItemToCart, ["prevent"])
                }, null, 8, ["format", "size", "label", "loading", "class", "disabled", "onClick"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})